/**
 * 兔斯平台相关
 */

import {localget} from './storage'
import {APP_FROM} from 'Config/index'
import { Toast } from 'vant';
import api from 'Plugins/api';

/**
 * 是否是兔斯平台
 * @returns {boolean}
 */
export function isTusi() {
  const param = localget('loginType') || ''
  return APP_FROM.tusu_123 == param
}

/**
 * 兔斯支付
 * @param orderId 订单id
 * @param orderType 订单类型
 */
export function toPayForTusi(orderId, orderType) {
  AppChannel.postMessage('getData');
  Toast.loading({message: '支付中...', loadingType: 'spinner', forbidClick: true, duration: 0});
  const appData = window.localStorage.getItem('appData');

  api['common/tusiPay']({orderId, orderType, headInfos: appData}).then(res => {
    const { cashierAddress, orderNo } = res.data || {};
    if (cashierAddress) {
      Toast.loading({message: '打开收银台...', loadingType: 'spinner', forbidClick: true, duration: 5000});

      // 30秒内没有返回结果，30秒后清除loading, 防止一直显示
      // const timer30 = setTimeout(() => (Toast.clear(), Toast.fail({message: '支付超时，请稍后再试', duration: 3000})), 30000);

      // window.location.href = cashierAddress;
      AppChannel.postMessage('toAliPay?' + cashierAddress + '&TMCOrderNo=' + orderNo);// 调用app的支付接口
    } else {
      Toast.fail({message: '支付失败', duration: 3000});
    }
  }).catch(ignore => {// 接口异常无需处理程序会自动处理
    console.log('toPayForTusi-catch', ignore)
  }).finally(() => {
  });
}